"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resource = void 0;
/**
 * Internal class for resources stored in an {@link ObjectResourceStore}.
 */
var Resource = /** @class */ (function () {
    function Resource(key, hash, promise) {
        var _this = this;
        this.key = key;
        this.hash = hash;
        this.promise = promise;
        this._status = "loading";
        this.timestamp = Date.now();
        promise
            .then(function (r) { return _this._succeed(r); })
            .catch(function (e) { return _this._fail(e); });
    }
    /**
     * Invoked when the promise resolves successfully.
     */
    Resource.prototype._succeed = function (result) {
        if (!this.isCancelled()) {
            this._status = "loaded";
            this._result = result;
        }
    };
    /**
     * Invoked when the promise is rejected.
     */
    Resource.prototype._fail = function (error) {
        if (!this.isCancelled()) {
            this._status = "error";
            this._error = error;
        }
    };
    /**
     * Indicates whether this resource is newer than another resource. Used to prevent race
     * conditions when a resource is replaced while it's still loading in the background.
     *
     * @param other The other resource.
     */
    Resource.prototype.isNewerThan = function (other) {
        return this.timestamp > other.timestamp;
    };
    /**
     * Marks this resource as no longer needed. See {@link ObjectResourceStore.discard}.
     */
    Resource.prototype.cancel = function () {
        this._status = "cancelled";
    };
    /**
     * If {@code true}, the {@link ObjectResourceStore} will ignore this resource if its
     * promise resolves or fails at any time in the future.
     */
    Resource.prototype.isCancelled = function () {
        return this._status === "cancelled";
    };
    /**
     * Returns a simplified representation of this resource that can be exposed to
     * painters or the application. Throws if {@link isCancelled} is {@code true}:
     * in that case it should be impossible for the resource to become visible.
     */
    Resource.prototype.forPublic = function () {
        switch (this._status) {
            case "loading":
                return { status: "loading" };
            case "loaded":
                return { status: "loaded", result: this._result };
            case "error":
                return { status: "error", error: this._error };
            case "cancelled":
                throw new Error("Internal error: attempted to expose a cancelled resource.");
        }
    };
    return Resource;
}());
exports.Resource = Resource;
//# sourceMappingURL=Resource.js.map